const mixpanelconfig = {
    AdminToken: 'ad7bc6eca40874d83f16c9ff5bd7e441',
    MemberToken: 'e4036d51b2758a7129363d61f3c373e5',
};

export default mixpanelconfig;
